module.exports = __webpack_public_path__ + "img/xj-dialog.c3d8a81d.jpg";